var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConstruction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#construction_svg__clip0_9084_51404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.57 26.437h31.312a2.939 2.939 0 100-5.88h-.072c-.355-5.602-3.634-10.41-8.332-12.91l-3.307 6.81V7.994c-.004-2.047-1.644-3.706-3.686-3.762-.135 0-.269-.003-.407-.003h-.04c-2.046.003-3.678 1.71-3.678 3.757v6.48l-3.666-6.82c-4.706 2.501-7.993 7.317-8.349 12.928a2.939 2.939 0 00.225 5.867v-.004zM38.224 38.53c-4.852 0-8.878-3.525-9.66-8.155h-5.832c.826 7.83 7.444 13.931 15.492 13.931 8.048 0 14.67-6.1 15.492-13.931h-5.832c-.786 4.626-4.812 8.155-9.66 8.155zm9.071 9.332H28.706c-10.675 0-18.135 6.645-18.135 16.163a3.634 3.634 0 003.631 3.631h47.601a3.634 3.634 0 003.631-3.63c0-9.515-7.46-16.16-18.135-16.16l-.004-.004zM16.755 61.73c.912-4.046 4.381-7.938 11.955-7.938H47.3c7.573 0 11.042 3.896 11.955 7.938h-42.5z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "construction_svg__clip0_9084_51404"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    transform: "translate(10.571 4.229)",
    d: "M0 0h54.863v63.429H0z"
  })))));
}

export default SvgConstruction;